/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { I18nProvider } from '../../providers/I18nProvider';
import { AdminSectionController } from './AdminSectionController';

export function AdminSection() {
  return (
    <I18nProvider>
      <AdminSectionController />
    </I18nProvider>
  );
}
